import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import TextInputField from "../../components/forms/TextInputField";
import FormError from "../../components/forms/FormError";

// Tags are edited as a comma separated string and always stored lower cased.
export function splitTags(value) {
  return (value || "")
    .split(",")
    .map((tag) => tag.trim().toLowerCase())
    .filter((tag) => tag.length > 0)
    .filter((tag, index, tags) => tags.indexOf(tag) === index);
}

export function tagsToString(tags) {
  return (tags || []).join(", ");
}

class OrderTagsForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit";
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field
              label="Tags"
              name="tags"
              placeholder="tag1, tag2"
              help="*Comma separated. Leave empty to remove all tags"
              component={TextInputField}
              spellCheck={false}
              autoCorrect="off"
              autoCapitalize="off"
              serverError={errors.tags}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "OrderTagsForm"
})(OrderTagsForm);

export default ReduxForm;
